import { updateTableSortConfigObject, tableSortList } from '../../../Common/TableHelper';
import { getCueSheetAckSortNode, getCueSheetAckSortType } from './config';

export const defaultCueSheetAckSortState = (config) => ({
    sortBy: 'Episode #',
    isSortByAsc: true,
    sortCount: 0,
    config: updateTableSortConfigObject(config, true, '', 'Episode #')
});

export const sortCueSheetAckListByEpisode = (list) =>
    tableSortList('Number', 'episode_number', list, true);

export const handleCueSheetAckTableColumnClick = (component, column) => {
    if (column === component.state.sortBy) {
        component.setState({ sortCount: component.state.sortCount + 1 }, () => {
            handleCueSheetAckTableSort(component, column);
        });
    } else {
        component.setState({ sortCount: 0 }, () => {
            handleCueSheetAckTableSort(component, column);
        });
    }
};

export const handleCueSheetAckTableSort = (component, colName) => {
    component.setState({
        isSortByAsc: component.state.sortCount % 2 === 0,
        config: updateTableSortConfigObject(component.state.config, component.state.isSortByAsc, component.state.sortBy, colName)
    }, () => {
        component.setState({
            sortBy: colName,
            renderList: tableSortList(
                getCueSheetAckSortType(colName),
                getCueSheetAckSortNode(colName),
                component.state.renderList,
                component.state.isSortByAsc
            )
        });
    });
};

export const openEpisodeCueSheet = (dataItem) => {
    window.open(`/episodeAndClearance/ss/${dataItem.show_season_id}/ep/${dataItem.show_season_episode_id}`, '_blank');
};

export const createCueSheetAckNavigationCallback = (component, showAiringErrors = false) => (dataItem, node) => {
    if (node === 'episode_number') {
        openEpisodeCueSheet(dataItem);
    } else if (showAiringErrors && node === 'airing') {
        component.setState({ selectedItem: dataItem?.rc_xml_cue_id });
    }
};
